import { Card, Row, Col, Typography } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";

const { Title } = Typography;

const StatCard = ({ title, value, icon, link }) => (
    <Card
        bordered={false}
        style={{
            height: "100%",
            borderRadius: "12px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            cursor: "pointer",
        }}
    >
        <Row align="middle" justify="space-between">
            {/* Left side: icon + text */}
            <Col>
                <Row align="middle" gutter={16}>
                    <Col style={{ fontSize: "50px", color: "#1890ff" }}>{icon}</Col>
                    <Col>
                        <Title level={5} style={{ margin: 0 }}>
                            {title}
                        </Title>
                        <p style={{ fontSize: "26px", fontWeight: "bold", margin: 0 }}>
                            {value}
                        </p>
                    </Col>
                </Row>
            </Col>

            {/* Right side: arrow */}
            {(link) && (
                <Col>
                    <a
                        href={link}
                        rel="noopener noreferrer"
                        style={{
                            fontSize: "35px",
                            color: "#1890ff",
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <ArrowRightOutlined />
                    </a>
                </Col>
            )}
        </Row>
    </Card>
);

export default StatCard;